export const priceBookLang = {
	label: {
		apply: 'Apply',
		current: 'Current',
		followCurrent: 'Follow Current',
		pricing: 'Pricing'
	},
	tooltip: {
		pinVersion: 'Choose the price book version this design is priced against'
	},
	message: {
		readonlyDesign: 'Saved versions are read-only, so the price book cannot be changed here.',
		finalized: 'This design is finalized, so the price book cannot be changed.',
		noVersionsPublished: 'No price book version has been published yet.',
		pinUnavailable: 'Pinning a price book version is not available yet.'
	}
};
